import { getQuoteForm } from '../../../selectors/motorPrivateRW/quote';
import {
    apiTransitionMotorInsuranceApiQuoteForm,
    submitMotorInsuranceApiQuoteSuccess
} from '../../../actions/motorPrivateRW/quote';
import { getAccessToken } from '../../../selectors/motorPrivateRW/payments';
import axios from 'axios';
import { getAgentForm, getIntermediaryType } from '../../../selectors/motorPrivateRW/travelAgentModal';

export const saveQuoteService = (store, next, action) => {
    (async () => {
        store.dispatch(apiTransitionMotorInsuranceApiQuoteForm.pending());
        try {
            const resp = await saveQuote(store.getState());
            store.dispatch(submitMotorInsuranceApiQuoteSuccess(resp.data));
            store.dispatch(apiTransitionMotorInsuranceApiQuoteForm.success());
        } catch (e) {
            console.error(e);
            store.dispatch(apiTransitionMotorInsuranceApiQuoteForm.failure());
        }
    })();
    return next(action);
};

function getLimitById(id, occupantLimits) {
    return occupantLimits.find(item => item.id === id)?.limit;
}

const saveQuotePayload = state => {
    const quotation = getQuoteForm(state);
    const agent = getAgentForm(state);
    const intermediaryType = getIntermediaryType(state);

    const payload = {
        fullName: quotation.fullName.value || 'N/A',
        make: parseInt(quotation.carMake.value?.id),
        model: parseInt(quotation.carModel.value?.id),
        yearOfManufacture: quotation.yearOfManufacture.value || 'N/A',
        sittingCapacity: parseInt(quotation.seatsNumber.value),
        numberOfOccupants: parseInt(quotation.coveredNumber.value),
        sumInsuredPerOccupant: getLimitById(quotation.sumInsured.value, quotation.occupantLimits.value?.data),
        use: quotation.carUse.value || 'N/A',
        carValue: quotation.carValue.value,
        agentCode: agent.agentCode.value || 'N/A',
        agentName: agent.name.value || 'N/A',
        refferedByAgent: intermediaryType.value === 'AGENTS' ? true : false,
        nationality: quotation.carReach.value,
        countryCode: 'RW',
        vehicle_type: quotation.vehicleType.value,
        payment_plan: quotation.insurancePaymentPlan.value,
        isComesa: quotation.carReach.value === 'rwanda' ? false : true
    };

    // Change payload here
    return {
        ...payload
    };
};

const saveQuote = async state => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/rw-motor-insurance/save/save-quote';
        return await axios.post(url, saveQuotePayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                Cookie: 'devEnvironment=ea-qa'
            }
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
